import { render, staticRenderFns } from "./PreviousMentorshipsTable.vue?vue&type=template&id=1cf1a3d9&scoped=true&"
import script from "./PreviousMentorshipsTable.vue?vue&type=script&lang=js&"
export * from "./PreviousMentorshipsTable.vue?vue&type=script&lang=js&"
import style0 from "./PreviousMentorshipsTable.vue?vue&type=style&index=0&id=1cf1a3d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf1a3d9",
  null
  
)

export default component.exports